<template>
	<div>
		<div class="header-item">
			<router-link :to="`/pages`" class="btn-back"></router-link>
			<h1>Add new page</h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li v-if="roles['Admin']"><router-link to="/pages/22/add/content">Content</router-link></li>
								<li v-if="roles['Admin']"><router-link to="/pages/22/add/metadata">Meta-data</router-link></li>
								<li v-if="roles['Admin']"><router-link to="/pages/22/add/options">Options</router-link></li>
								<li>
									<LangSwitch type="multiple" v-bind:downloadCallback="getMarketsCompleteHandler"></LangSwitch>
								</li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view :entities="content" :markets="markets"></router-view>
	</div>
</template>

<script>

import LangSwitch from '../../components/LangSwitch.vue'

export default {
	name: 'addpages',
	props: {
		content: Array
	},
	data () {
		return {
			roles: this.$store.state.user.roles,
			user: this.$store.state.user,
			markets: null
		}
	},

	components: {
		'LangSwitch': LangSwitch
	},

	created () {

	},

	methods: {
		getMarketsCompleteHandler (data) {
			this.markets = data
		}
	}

}
</script>
